import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RedirectionComponent } from './component/error/redirection/redirection.component';
import {
  authenticationCanMatch,
  authenticationGuard,
} from './guards/authentication.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./component/homepage/homepage.module').then(
        (m) => m.HomepageModule,
      ),
  },
  {
    path: 'destinations/:destination/:id',
    loadChildren: () =>
      import('./component/destinations/destinations.module').then(
        (m) => m.DestinationsModule,
      ),
  },
  {
    path: 'offers-deals',
    loadChildren: () =>
      import('./component/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'tours',
    loadChildren: () =>
      import('./component/tours/tours.module').then((m) => m.ToursModule),
  },
  {
    path: 'weddings-honeymoons',
    loadChildren: () =>
      import('./component/weddings/weddings.module').then(
        (m) => m.WeddingsModule,
      ),
  },
  {
    path: 'destinations/:destination/:hotel/:id',
    loadChildren: () =>
      import('./component/sub/sub.module').then((m) => m.SubModule),
  },
  {
    path: 'about-us',
    loadChildren: () =>
      import('./component/about/about.module').then((m) => m.AboutModule),
  },
  {
    path: 'blog',
    loadChildren: () =>
      import('./component/blog/blog.module').then((m) => m.BlogModule),
  },
  {
    path: 'themes/:theme',
    loadChildren: () =>
      import('./component/themes/themes.module').then((m) => m.ThemesModule),
  },
  {
    path: 'travelwise',
    loadChildren: () =>
      import('./component/travel-wise/travel-wise.module').then(
        (m) => m.TravelWiseModule,
      ),
  },
  {
    path: 'tours/:hotel/:id',
    loadChildren: () =>
      import('./component/tour-packages/tour-packages.module').then(
        (m) => m.TourPackagesModule,
      ),
  },
  // Circuits d'une destination (ex. /touring/usa-tours/<id>) : pas sous /tours,
  // où deux segments désignent déjà une fiche circuit.
  {
    path: 'touring/:destination/:id',
    loadChildren: () =>
      import('./component/touring/touring.module').then((m) => m.TouringModule),
  },
  {
    path: 'contact-us',
    loadChildren: () =>
      import('./component/contact-us/contact-us.module').then(
        (m) => m.ContactUsModule,
      ),
  },
  {
    path: 'request-quote',
    loadChildren: () =>
      import('./component/request-quote/request-quote.module').then(
        (m) => m.RequestQuoteModule,
      ),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./component/error/error.module').then((m) => m.ErrorModule),
    data: { status: 404 },
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./component/privacy-policy/privacy-policy.module').then(
        (m) => m.PrivacyPolicyModule,
      ),
  },
  {
    path: 'booking-conditions',
    loadChildren: () =>
      import('./component/booking-conditions/booking-conditions.module').then(
        (m) => m.BookingConditionsModule,
      ),
  },
  {
    path: 'summer',
    loadChildren: () =>
      import('./component/summer/summer.module').then((m) => m.SummerModule),
  },
  {
    path: 'winter',
    loadChildren: () =>
      import('./component/winter/winter.module').then((m) => m.WinterModule),
  },
  {
    path: 'autumn',
    loadChildren: () =>
      import('./component/autumn/autumn.module').then((m) => m.AutumnModule),
  },
  {
    path: 'spring',
    loadChildren: () =>
      import('./component/spring/spring.module').then((m) => m.SpringModule),
  },
  { path: 'redirection', component: RedirectionComponent },
  {
    path: 'subscribe',
    loadChildren: () =>
      import('./component/souscription/souscription.module').then(
        (m) => m.SouscriptionModule,
      ),
  },
  {
    path: 'articles/:article',
    loadChildren: () =>
      import('./component/single-article/single-article.module').then(
        (m) => m.SingleArticleModule,
      ),
  },
  {
    path: 'categories/:category',
    loadChildren: () =>
      import('./component/category/category.module').then(
        (m) => m.CategoryModule,
      ),
  },
  {
    path: 'all-articles',
    loadChildren: () =>
      import('./component/all-articles/all-articles.module').then(
        (m) => m.AllArticlesModule,
      ),
  },
  {
    path: 'explore-luxury-holidays',
    loadChildren: () =>
      import('./component/video-viewer/video-viewer.module').then(
        (m) => m.VideoViewerModule,
      ),
  },
  {
    path: 'admin',
    canActivate: [authenticationGuard],
    canMatch: [authenticationCanMatch],
    loadChildren: () =>
      import('./component/admin/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
  },

  // Chargées à la demande : l'écran de connexion admin n'a rien à faire
  // dans le bundle initial des pages publiques.
  {
    path: 'login',
    loadComponent: () =>
      import('./component/admin/auth/auth.component').then(
        (m) => m.AuthComponent,
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./component/admin/auth/auth.component').then(
        (m) => m.AuthComponent,
      ),
    data: { view: 'reset' },
  },
  /* {
    path: 'blackfriday',
    loadChildren: () =>
      import('./component/blackfriday/blackfriday.module').then(
        (m) => m.BlackfridayModule
      ),
  },
  {
    path: 'blackfriday-conditions',
    loadChildren: () =>
      import(
        './component/term-condition-blackfriday/term-condition-blackfriday.module'
      ).then((m) => m.TermConditionBlackfridayModule),
  },
   {
    path: 'generatexml',
     loadChildren: () =>
      import('./component/xml-generator/xml-generator.module').then(
      (m) => m.XmlGeneratorModule
      ),
   },
  /*{
    path: 'admin',
    canActivate: [authenticationCanMatch],
    canMatch: [authenticationCanMatch],
    // component: AdminLayoutComponent,
    children: [
      {
        path: 'generatexml',
        loadChildren: () =>
          import('./component/xml-generator/xml-generator.module').then(
            (m) => m.XmlGeneratorModule,
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('./component/admin/admin-dasboard/admin-dasboard.module').then(
            (m) => m.AdminDasboardModule,
          ),
      },
      {
        path: 'generatexml',
        loadChildren: () =>
          import('./component/xml-generator/xml-generator.module').then(
            (m) => m.XmlGeneratorModule,
          ),
      },
      {
        path: 'hotels',
        children: [
          {
            path: '',
            loadChildren: () =>
              import('./component/admin/hotels/hotels.module').then(
                (m) => m.HotelsModule,
              ),
          },
          {
            path: ':mode',
            loadChildren: () =>
              import('./component/admin/add-hotel/add-hotel.module').then(
                (m) => m.AddHotelModule,
              ),
          },
        ],
        //  component: HotelsComponent,
      },
      {
        path: 'carnet-voyage',
        //  component: HotelsComponent,
        loadChildren: () =>
          import('./component/admin/carnet-voyage/carnet-voyage.module').then(
            (m) => m.CarnetVoyageModule,
          ),
      },
      {
        path: 'carnet-voyage/voyage-details/:quoteId',
        //  component: HotelsComponent,
        loadChildren: () =>
          import('./component/admin/carnet-voyage-details/carnet-voyage-details.module').then(
            (m) => m.CarnetVoyageDetailsModule,
          ),
      },
      {
        path: 'destinations',
        children: [
          {
            path: '',
            loadChildren: () =>
              import('./component/admin/list-destinations/list-destinations.module').then(
                (m) => m.ListDestinationsModule,
              ),
          },
          // {
          //   path: '',
          //   loadChildren: () =>
          //     import(
          //       './component/admin/edit-destinations/edit-destinations.module'
          //     ).then((m) => m.EditDestinationsModule),
          // },
        ],
      },
      { path: '', redirectTo: 'hotels', pathMatch: 'full' },
    ],
  },

  {
    path: 'trending-honeymoons/:continent',
    loadChildren: () =>
      import('./component/trending-honeymoon/trending-honeymoon.module').then(
        (m) => m.TrendingHoneymoonModule,
      ),
  },
  {
    path: 'honeymoon',
    loadChildren: () =>
      import('./component/honeymoon/honeymoon.module').then(
        (m) => m.HoneymoonModule,
      ),
  },*/
  /*{
    path: 'competition',
    loadChildren: () =>
      import('./component/competition/competition.module').then(
        (m) => m.CompetitionModule
      ),
  },
  {
    path: 'competition-terms-and-conditions',
    loadChildren: () =>
      import('./component/competition-terms/competition-terms.module').then(
        (m) => m.CompetitionTermsModule
      ),
  },*/
  /*{
    path: 'september-peak-sale',
    loadChildren: () =>
      import('./component/festive-sale/festive-sale.module').then(
        (m) => m.FestiveSaleModule,
      ),
  },
  // Ancienne URL conservée : les liens et backlinks existants ne doivent pas tomber en 404
  {
    path: 'july-sale',
    redirectTo: 'september-peak-sale',
    pathMatch: 'full',
  },*/
  { path: '**', redirectTo: '/error' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      errorHandler: (error) => {
        if (error.message && error.message.includes('ChunkLoadError')) {
          console.error('ChunkLoadError occurred:', error);
          if (typeof window !== 'undefined') {
            window.location.reload();
          }
        }
      },
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
